'use strict'

$.fn.textWidth = function() {
	if (this.length > 1)
		throw new Error('Applying $.textWidth to multiple nodes')
	var origHtml = $(this).html()
	$(this).html('<span>' + origHtml + '</span>')
	var width = $(this).children('span:first').width()
	$(this).html(origHtml)
	return width
}


/*****************
 ** WEBPACK FOOTER
 ** ./helpers/jquery.textWidth.js
 ** module id = 159
 ** module chunks = 0
 **/